import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';

import { Sitecore } from '@frontend/sports/common/client-config-data-access';
import { MoneyService } from '@frontend/sports/common/core/feature/money';
import { StringInterpolationPipe } from '@frontend/sports/common/core/utils/string-interpolation';
import { Store } from '@ngrx/store';
import { Decimal } from 'decimal.js';
import { map } from 'rxjs';

import { IBetslipRootState } from '../../../../base/store/state';
import { PickId } from '../../../../core/picks/pick-id';
import { BetslipV2HorseRaceWinParticipantPick } from '../../../../core/picks/sport-specific/betslip-v2-horse-race-picks';
import { betslipPickStateSelector } from '../../../picks/selectors';
import { findQuickBetPicks } from '../../services/quick-bet-utils.service';

@Component({
    selector: 'bs-quick-bet-taxation-za',
    templateUrl: './quick-bet-taxation-za.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    styleUrls: ['./quick-bet-taxation-za.component.scss'],
    standalone: false,
})
export class QuickBetTaxationZaComponent {
    @Input() pickIds: PickId[];
    @Input() gross: Decimal;
    @Input() tax: Decimal;

    private readonly pickState$ = this.store.select(betslipPickStateSelector);
    private readonly picks$ = this.pickState$.pipe(map((state) => findQuickBetPicks(state.pickList, this.pickIds)));

    readonly showTaxation$ = this.picks$.pipe(map((picks) => picks.some((pick) => pick instanceof BetslipV2HorseRaceWinParticipantPick)));

    @HostBinding() className = 'quick-bet__taxation-info-za';

    constructor(
        private store: Store<IBetslipRootState>,
        private interpolationPipe: StringInterpolationPipe,
        private moneyService: MoneyService,
        private sitecore: Sitecore,
    ) {}

    get taxationInfo(): string {
        return this.interpolationPipe.transform(this.sitecore.quickBetMessages.TaxationInfo, {
            gross: this.moneyService.transform(this.gross, true),
            tax: this.moneyService.transform(this.tax, true),
        });
    }
}
